import Service from "./abstract/Service";

export default class TranslationService extends Service {

  findByIso(language = null) {
    return this.get(env.APP_URL + `/translations/${language}`);
  }
}
